// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"af7f90c2","434":"6968ac99","515":"35683603"}[chunkId] + ".chunk.js";
};